export const UI_TEXT = {
  SEARCH: {
    TITLE: 'Search metrics',
  },
  METRIC_SELECT_SCENE: {
    OPEN_EXPLORE_LABEL: 'Open in explore',
    COPY_URL_LABEL: 'Copy url',
    BOOKMARK_LABEL: 'Bookmark',
    SELECT_NEW_METRIC_TOOLTIP: 'Remove existing metric and choose a new metric',
  },
};
